import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { cancelPastDuePreviousSubscription } from '@utils/backend-api/subscribe';

const useSubscriptionCancelationForPastDue = () => {
  const { mutate, mutateAsync, isLoading, isError } = useMutation(
    () => cancelPastDuePreviousSubscription(),
    {
      onError: (error: { message: string }) => {
        toast.error(error.message);
      },
    }
  );
  return { mutate, mutateAsync, isLoading, isError };
};

export default useSubscriptionCancelationForPastDue;
